import router from '@/services/routes'

export default {
	setAxiosToken (context, payload) {
		context.commit('SET_AXIOS_TOKEN', payload)
	},
	setGuestId (context, payload) {
		context.commit('SET_GUEST_ID', payload)
	},
	setReady (context, payload) {
		context.commit('SET_READY', payload)
	},
	setAvailableLanguages (context, payload) {
		context.commit('SET_AVAILABLE_LANGUAGES', payload)
	},
	setLoading (context, payload) {
		context.commit('SET_LOADING', payload)
	},
	setTranslations (context, payload) {
		context.commit('SET_TRANSLATIONS', payload)
	},
	setTheme (context, payload) {
		context.commit('SET_THEME', payload)
	},
	setNavigationState (context, payload) {
		context.commit('SET_NAVIGATION_STATE', payload);
	},
	setUser (context, payload) {
		context.commit('SET_USER', payload)
		window.localStorage.setItem('ESCREEN_USER', JSON.stringify(payload))
	},
	setTeams (context, payload) {
		context.commit('SET_TEAMS', payload)
	},
	setTeam (context, payload) {
		context.commit('SET_TEAM', payload)
	},
	setTeamPlan (context, payload) {
		context.commit('SET_TEAM_PLAN', payload)
	},
	setLeaveConfirmation (context, payload) {
		context.commit('SET_LEAVE_CONFIRMATION', payload)
	},
	setAuth (context, payload) {
		payload.expires_at = payload.expires_in + Math.round(Date.now() / 1000)
		context.commit('SET_AUTH', payload)
		window.localStorage.setItem('ESCREEN_AUTH', JSON.stringify(payload))
	},
	setShowSwitchTeam (context, payload) {
		context.commit('SET_SHOW_SWITCH_TEAM', payload)
	},
	setShowExpirationDialog (context, payload) {
		context.commit('SET_SHOW_EXPIRATION_DIALOG', payload)
	},
	setShowPlanLimitDialog (context, payload) {
		context.commit('SET_SHOW_PLAN_LIMIT_DIALOG', payload)
	},
	login (context, payload) {
		context.dispatch('setAuth', payload)
	},
	logout (context, payload) {
		context.commit('SET_AUTH', {})
		context.commit('SET_USER', {})
		context.commit('SET_TEAM', {})
		context.commit('SET_TEAMS', [])
		window.localStorage.removeItem('ESCREEN_USER')
		window.localStorage.removeItem('ESCREEN_GUEST')
		window.localStorage.removeItem('ESCREEN_AUTH')
		if (payload) {
			router.push('/login').catch(()=>{})
		}
	}
}
